import {html, ref, unsafeHTML} from "../../../../admin/script/libs/lit.dist.js";
import {formatDate} from "../../../util/datetime.js";
import {bytesToUnit} from "../../../util/number.js";
import {File} from "../../../../admin/script/models/file.js";
import {KNOWLEDGE_BASE_ICONS, LINK_ICONS, MESSAGE_ORIGIN_CUSTOMER, MESSAGE_ORIGIN_EMPLOYEE} from "../types.js";
import {scrollToBottom} from "../../../../admin/script/util/browser.js";
import '../../../../admin/script/custom-elements/pk-spinner.js';

const linksTemplate = (links, title) => {
    if (!links || links.length <= 0) {
        return null;
    }
    return html`
        <div class="mt-3">
            ${title ? html`<span class="fs-sm">${title}</span>` : null}
            <ul class="mt-1 list-unstyled">
                ${links.map(link => html`
                    <li class="fs-sm">
                        <a href="${link.url}" target="_blank" class="d-flex">
                            <i class="${LINK_ICONS[link.icon || '']} me-1"></i>
                            ${link.title}
                        </a>
                    </li>
                `)}
            </ul>
        </div>
    `;
}

const suggestionTemplate = (suggestion, onClick) => {
    let label = suggestion;
    let handler = suggestion;
    try {
        if (suggestion.substring(0, 1) === '[') {
            const data = JSON.parse(suggestion);
            handler = data[0];
            label = data[1];
        }
    } catch (e) {
    }
    return html` 
        <span class="btn btn-light btm-sm mb-1 me-1 fs-sm text-left border border-gray-200" @click="${() => onClick(handler, suggestion)}">
            ${label}
        </span>
    `;
};

const authorInitials = name => {
    const parts = String(name).toUpperCase().split(' ');
    return String(parts[0]).substring(0, 1) + String(parts[1]).substring(0, 1);
};

export default ({messages, message, ...props}) => html`
    <div class="d-flex flex-column h-100">
        <div class="d-flex mt-n3 mx-n3">
            <button type="button" class="btn btn-icon ms-auto fs-4 p-2" @click="${props.toggleChat}" title="Zamknij czat">
                <i class="bi bi-x"></i>
            </button>
        </div>
        <div class="flex-grow-1 pb-4 overflow-auto user-chat-messages-container" ${ref(props.messagesContainerRef)} ${ref(scrollToBottom)}>
            ${props.isMessagesRequested && messages.length === 0 ? html`
                <div class="d-flex align-items-center align-content-center h-100">
                    <pk-spinner class="mx-auto"></pk-spinner>
                </div>
            ` : null}
            ${messages.map((message, i) => {
                const previousMessage = messages[i - 1];
                const nextMessage = messages[i + 1];
                const isSameSession = previousMessage && (!message.chat_id || previousMessage.chat_id === message.chat_id);
                const isSameAsPrevious = isSameSession && previousMessage && previousMessage.origin === message.origin;
                return html`
                    ${previousMessage && !isSameSession ? html`
                        <div class="pk-user-chat-session-separator"></div>
                    ` : null}
                    <div class="ticket-timeline--message ticket-timeline--message-${message.origin === MESSAGE_ORIGIN_CUSTOMER ? 'customer' : 'employee'} ticket-timeline--message-origin-${message.origin} ticket-timeline--message-type-${message.type} ${isSameAsPrevious ? 'ticket-timeline--message-same-as-previous' : ''}">
                        ${message.origin === MESSAGE_ORIGIN_EMPLOYEE && message.autor_name && (!previousMessage || previousMessage.autor_name !== message.autor_name) ? html`
                            <div class="ticket-timeline--message-header">
                                <div class="ticket-timeline--user-avatar me-1">${authorInitials(message.autor_name)}</div>
                                <div class="ticket-timeline--user-name">${message.autor_name} <small>(Polkurier.pl)</small></div>
                            </div>
                        ` : ''}    
                        <div class="ticket-timeline--message-body">
                            <div class="ticket-timeline--message-content text-pre-wrap">${unsafeHTML(message.content)}</div>
                            ${message.attachments && message.attachments.length > 0 ? html`
                                <div class="ticket-timeline--message-files">
                                    <ul>
                                        ${message.attachments.map(attachment => {
                                            const file = new File(attachment);
                                            return html`
                                                <li class="ticket-timeline--message-files--file-${attachment.type.replace('/', '-')} mb-2">
                                                    <a href="${attachment.url || '#'}">
                                                        ${attachment.url && file.isImage() ? html`
                                                            <img src="${attachment.url}" alt="">
                                                        ` : html`
                                                            <span class="d-flex align-items-center">
                                                                <i class="fa ${file.getFaIconName()} me-1"></i>
                                                                <span class="text-nowrap overflow-hidden text-overflow-ellipsis flex-shrink-1">${attachment.name}</span>
                                                                <small class="text-nowrap ms-1">(${bytesToUnit(attachment.size)})</small>
                                                            </span>
                                                        `}
                                                    </a>
                                                </li>
                                            `;
                                        })}
                                    </ul>
                                </div>
                            ` : null}
                            ${linksTemplate((message.links || []).filter(link => KNOWLEDGE_BASE_ICONS.indexOf(link.icon) === -1))}
                            ${linksTemplate(
                                (message.links || []).filter(link => KNOWLEDGE_BASE_ICONS.indexOf(link.icon) !== -1),
                                    'Więcej informacji znajdziesz w bazie wiedzy:'
                            )}
                            <div class="ticket-timeline--message-date">
                                ${message.isBeingSend ? html`<pk-spinner size="sm" color="dark"></pk-spinner>` : null}
                                ${formatDate(message.date, 'Pp') }
                            </div>
                        </div>
                    </div>
                    ${!nextMessage && message.suggestions && message.suggestions.length > 0 && !props.isAwaitingResponse ? html`
                        <div class="mt-1 mx-2 ${message.origin === MESSAGE_ORIGIN_CUSTOMER ? 'text-right' : ''}">
                            ${message.suggestions.map(suggestion => suggestionTemplate(suggestion, props.onClickSuggestion))}
                        </div>
                    ` : null}
                `;
            })}
            ${props.isAwaitingResponse ? html`
                <div class="ticket-timeline--message ticket-timeline--message-employee" ${ref(props.scrollToBottom)}>
                    <div class="ticket-timeline--message-body">
                        <div class="ticket-timeline--message-content text-nowrap text-center">
                            <div class="spinner-grow spinner-grow-sm text-dark" role="status"></div>
                        </div>
                    </div>
                </div>
            ` : null}
        </div>
        <div class="pt-2 flex-grow-0">
            ${props.showResponseInput ? html`
                <div class="input-group">
                    <input 
                        class="form-control"
                        placeholder="Twoja wiadomość"
                        .value="${message.content}" 
                        @input="${e => props.setMessageContent(e.target.value)}"
                        @keyup="${e => {
                            if (message.content && !props.isUploadingFile && e.key === 'Enter') {
                                props.onClickSendButton();
                            }
                        }}"
                        @paste="${props.onPaste}"
                    />
                    <div class="btn btn-input position-relative">
                        ${props.isUploadingFile ? html`
                            <pk-spinner size="sm"></pk-spinner>
                        ` : html`
                            <input type="file" class="input-file position-absolute top-0 start-0 w-100 h-100 opacity-0 cursor-pointer" @input="${props.onSelectFile}" multiple />
                            <i class="bi bi-paperclip"></i>
                        `}
                        ${message.attachments && message.attachments.length > 0 ? html`
                            <div class="card chat-attached-files">
                                <div class="card-body">
                                    ${message.attachments.map(attachment => {
                                        const file = new File(attachment);
                                        return html`
                                            <span class="chat-attached-file">
                                                <a href="${attachment.url || '#'}" target="_blank">
                                                    ${attachment.url && file.isImage() ? html`
                                                        <img src="${attachment.url}" alt="">
                                                    ` : html`
                                                        <span class="d-flex align-items-center" title="${attachment.name}">
                                                            <i class="fa ${file.getFaIconName()} me-1"></i>
                                                            <span class="text-nowrap overflow-hidden text-overflow-ellipsis flex-shrink-1">${attachment.name}</span>
                                                        </span>
                                                    `}
                                                </a>
                                                <button class="btn btn-link" @click="${() => props.onClickRemoveAttachedFile(attachment)}">
                                                    <i class="bi bi-x"></i>
                                                </button>
                                            </span>
                                        `;
                                    })}
                                </div>
                            </div>
                        ` : null}
                    </div>
                    ${props.showTakePhotoButton ? html`
                        <button class="btn btn-input" @click="${props.showTakePhotoModal}">
                            <i class="bi bi-camera"></i>
                        </button>
                    ` : null}
                    <button 
                        class="btn btn-primary" 
                        @click="${props.onClickSendButton}" 
                        .disabled="${(!message.content && message.attachments.length === 0) || props.isUploadingFile}"
                    >
                        <i class="bi bi-send"></i>
                    </button>
                </div>
            ` : null}
        </div>
    </div>

`;
